import { render, staticRenderFns } from "./ViewOtherServices.vue?vue&type=template&id=5c78dd40&"
import script from "./ViewOtherServices.vue?vue&type=script&lang=js&"
export * from "./ViewOtherServices.vue?vue&type=script&lang=js&"
import style0 from "./ViewOtherServices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports